export default {
	short: 100,
	med: 250,
	long: 500,

	ease: 'ease-in-out',
}
